import { enableNotifications, disableNotifications, permissionState, notificationsSupported } from '../notifications.js';

export const SidebarLayout = {
  template: "#sidebar-layout",
  inject: ["user", "isAuthenticated", "handleLogout"],
  data() {
    return {
      notifSupported: notificationsSupported(),
      notifPermission: permissionState(),
      notifBusy: false,
      isSidebarCollapsed: false,
      isSidebarOpen: false, 
      isMobile: false,
      navigationItems: [
        {
          path: "/",
          label: "Dashboard",
          icon: "bi-graph-up"
        },
        {
          path: "/schedule",
          label: "Schedule",
          icon: "bi-calendar"
        },
        {
          path: "/invoices",
          label: "Invoices",
          icon: "bi-send"
        },
        {
          path: "/expenses",
          label: "Expenses",
          icon: "bi-wallet2"
        }
      ]
    };
  },
  computed: {
    notifEnabled() {
      return this.notifPermission === 'granted';
    },
    notifDenied() {
      return this.notifPermission === 'denied';
    },

    userEmail() {
      return this.user?.email || "";
    },
    userName() {
      return this.user?.displayName || this.userEmail?.split("@")[0] || "User";
    },
    userInitial() {
      return this.userName.charAt(0).toUpperCase();
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    async toggleNotifications() {
      this.notifBusy = true;
      try {
        const result = this.notifEnabled
          ? await disableNotifications()
          : await enableNotifications();
        if (!result.ok && result.reason === 'denied') {
          // Nothing the app can do: once blocked, only the user can undo it in
          // browser site settings.
          console.warn('Notifications blocked for this site.');
        }
      } finally {
        this.notifPermission = permissionState();
        this.notifBusy = false;
      }
    },

    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
      if (this.isMobile) {
        this.isSidebarOpen = false;
      } else {
        this.isSidebarOpen = true;
      }
    },
    toggleSidebar() {
      if (this.isMobile) {
        this.isSidebarOpen = !this.isSidebarOpen;
      } else {
        this.isSidebarCollapsed = !this.isSidebarCollapsed;
      }
    },
    isActiveRoute(path) {
      return this.$route.path === path;
    }
  }
};
